/* eslint-disable no-unused-vars */
import { REQUEST, SUCCESS, FAILURE, createReducer, updateObject } from '../../../store'
import { DEFAULT_PAG } from '../../../constants'
import { editArray } from '../../../utils/utils'
import {
  LOAD_COURSE_ACTIVITY_USER_LIST,
  LOAD_STUDY_COURSE_TIME,
  LOAD_STUDY_COURSE_HISTORY,
  LOAD_COURSE_RANKING_ALL,
  LOAD_COURSE_RANKING_NISSOKEN,
  LOAD_COURSE_RANKING_COMPANY,
  UPDATE_BOOKMARK
} from './constants'

export const initialState = {
  userList: {
    isLoading: false,
    data: [],
    error: null
  },
  studyCourseTime: {
    isLoading: false,
    data: {
      userId: null,
      sumStudyTime: 0,
      nissokenStudyTime: 0,
      companyStudyTime: 0
    },
    error: null
  },
  studyCourseHistory: {
    isLoading: false,
    data: {
      total: 0,
      limit: 10,
      page: 1,
      pages: 1,
      result: []
    },
    error: null
  },
  courseRankingAll: {
    isLoading: false,
    isUpdatingBookmark: false,
    data: {
      ...DEFAULT_PAG,
      limit: 5,
      result: []
    },
    error: null
  },
  courseRankingNissoken: {
    isLoading: false,
    data: {
      ...DEFAULT_PAG,
      limit: 5,
      result: []
    },
    error: null
  },
  courseRankingCompany: {
    isLoading: false,
    data: {
      ...DEFAULT_PAG,
      limit: 5,
      result: []
    },
    error: null
  }
}

function loadCourseActivityUserList(state) {
  return updateObject(state, {
    userList: {
      ...state.userList,
      isLoading: true,
      error: null
    }
  })
}

function loadCourseActivityUserListSuccess(state, { data }) {
  return updateObject(state, {
    userList: {
      ...state.userList,
      data,
      isLoading: false,
      error: null
    }
  })
}

function loadStudyCourseTime(state) {
  return updateObject(state, {
    studyCourseTime: {
      ...state.studyCourseTime,
      isLoading: true,
      error: null
    }
  })
}

function loadStudyCourseTimeSuccess(state, { data }) {
  return updateObject(state, {
    studyCourseTime: {
      ...state.studyCourseTime,
      data,
      isLoading: false,
      error: null
    }
  })
}

function loadStudyCourseTimeError(state, { error }) {
  return updateObject(state, {
    studyCourseTime: {
      ...state.studyCourseTime,
      isLoading: false,
      error
    }
  })
}

function loadStudyCourseHistory(state) {
  return updateObject(state, {
    studyCourseHistory: {
      ...state.studyCourseHistory,
      isLoading: true,
      error: null
    }
  })
}

function loadStudyCourseHistorySuccess(state, { data }) {
  return updateObject(state, {
    studyCourseHistory: {
      ...state.studyCourseHistory,
      data,
      isLoading: false,
      error: null
    }
  })
}

function loadStudyCourseHistoryError(state, { error }) {
  return updateObject(state, {
    studyCourseHistory: {
      ...state.studyCourseHistory,
      isLoading: false,
      error
    }
  })
}

function loadCourseRankingAll(state) {
  return updateObject(state, {
    courseRankingAll: {
      ...state.courseRankingAll,
      isLoading: true,
      error: null
    }
  })
}

function loadCourseRankingAllSuccess(state, { data }) {
  return updateObject(state, {
    courseRankingAll: {
      ...state.courseRankingAll,
      data,
      isLoading: false,
      error: null
    }
  })
}

function loadCourseRankingAllError(state, { error }) {
  return updateObject(state, {
    courseRankingAll: {
      ...state.courseRankingAll,
      isLoading: false,
      error
    }
  })
}

function loadCourseRankingNissoken(state) {
  return updateObject(state, {
    courseRankingNissoken: {
      ...state.courseRankingNissoken,
      isLoading: true,
      error: null
    }
  })
}

function loadCourseRankingNissokenSuccess(state, { data }) {
  return updateObject(state, {
    courseRankingNissoken: {
      ...state.courseRankingNissoken,
      data,
      isLoading: false,
      error: null
    }
  })
}

function loadCourseRankingNissokenError(state, { error }) {
  return updateObject(state, {
    courseRankingNissoken: {
      ...state.courseRankingNissoken,
      isLoading: false,
      error
    }
  })
}

function loadCourseRankingCompany(state) {
  return updateObject(state, {
    courseRankingCompany: {
      ...state.courseRankingCompany,
      isLoading: true,
      error: null
    }
  })
}

function loadCourseRankingCompanySuccess(state, { data }) {
  return updateObject(state, {
    courseRankingCompany: {
      ...state.courseRankingCompany,
      data,
      isLoading: false,
      error: null
    }
  })
}

function loadCourseRankingCompanyError(state, { error }) {
  return updateObject(state, {
    courseRankingCompany: {
      ...state.courseRankingCompany,
      isLoading: false,
      error
    }
  })
}

function updateBookmark(state) {
  return updateObject(state, {
    courseRankingAll: {
      ...state.courseRankingAll,
      isUpdatingBookmark: true,
      error: null
    },
    courseRankingNissoken: {
      ...state.courseRankingNissoken,
      isUpdatingBookmark: true,
      error: null
    },
    courseRankingCompany: {
      ...state.courseRankingCompany,
      isUpdatingBookmark: true,
      error: null
    }
  })
}

function updateBookmarkSuccess(state, { payload }) {
  const { item, data } = payload
  const newItem = { ...item, isBookmark: data.isBookmark }
  const newCourseRankingAll = editArray(state.courseRankingAll.data.result, newItem, (el) => el.courseId === item.courseId)
  const newCourseRankingNissoken = editArray(state.courseRankingNissoken.data.result, newItem, (el) => el.courseId === item.courseId)
  const newCourseRankingCompany = editArray(state.courseRankingCompany.data.result, newItem, (el) => el.courseId === item.courseId)

  return updateObject(state, {
    courseRankingAll: {
      ...state.courseRankingAll,
      data: {
        ...state.courseRankingAll.data,
        result: newCourseRankingAll
      },
      isUpdatingBookmark: false
    },
    courseRankingNissoken: {
      ...state.courseRankingNissoken,
      data: {
        ...state.courseRankingNissoken.data,
        result: newCourseRankingNissoken
      },
      isUpdatingBookmark: false
    },
    courseRankingCompany: {
      ...state.courseRankingCompany,
      data: {
        ...state.courseRankingCompany.data,
        result: newCourseRankingCompany
      },
      isUpdatingBookmark: false
    }
  })
}

export default createReducer(initialState, {
  [REQUEST(LOAD_COURSE_ACTIVITY_USER_LIST)]: loadCourseActivityUserList,
  [SUCCESS(LOAD_COURSE_ACTIVITY_USER_LIST)]: loadCourseActivityUserListSuccess,

  [REQUEST(LOAD_STUDY_COURSE_TIME)]: loadStudyCourseTime,
  [SUCCESS(LOAD_STUDY_COURSE_TIME)]: loadStudyCourseTimeSuccess,
  [FAILURE(LOAD_STUDY_COURSE_TIME)]: loadStudyCourseTimeError,

  [REQUEST(LOAD_STUDY_COURSE_HISTORY)]: loadStudyCourseHistory,
  [SUCCESS(LOAD_STUDY_COURSE_HISTORY)]: loadStudyCourseHistorySuccess,
  [FAILURE(LOAD_STUDY_COURSE_HISTORY)]: loadStudyCourseHistoryError,

  [REQUEST(LOAD_COURSE_RANKING_ALL)]: loadCourseRankingAll,
  [SUCCESS(LOAD_COURSE_RANKING_ALL)]: loadCourseRankingAllSuccess,
  [FAILURE(LOAD_COURSE_RANKING_ALL)]: loadCourseRankingAllError,

  [REQUEST(LOAD_COURSE_RANKING_NISSOKEN)]: loadCourseRankingNissoken,
  [SUCCESS(LOAD_COURSE_RANKING_NISSOKEN)]: loadCourseRankingNissokenSuccess,
  [FAILURE(LOAD_COURSE_RANKING_NISSOKEN)]: loadCourseRankingNissokenError,

  [REQUEST(LOAD_COURSE_RANKING_COMPANY)]: loadCourseRankingCompany,
  [SUCCESS(LOAD_COURSE_RANKING_COMPANY)]: loadCourseRankingCompanySuccess,
  [FAILURE(LOAD_COURSE_RANKING_COMPANY)]: loadCourseRankingCompanyError,

  [REQUEST(UPDATE_BOOKMARK)]: updateBookmark,
  [SUCCESS(UPDATE_BOOKMARK)]: updateBookmarkSuccess
})
